import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAppState from 'context/useAppState';

// Guard khusus modul BAST Security: wajib login DAN hanya role "Security" yang boleh masuk.
export default function SecurityRoute() {
  const { isAuthenticated, data } = useAppState((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  const isSecurity = data?.user?.role_name === 'Security';

  useEffect(() => {
    // Belum login → arahkan ke login dengan menyimpan tujuan
    if (!isAuthenticated) {
      const redirectLink = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?continue=${redirectLink}`, { replace: true, state: location });
      return;
    }

    // Sudah login tapi bukan role Security → tolak akses
    if (!isSecurity) {
      navigate('/no-access', { replace: true });
    }
  }, [navigate, location, isAuthenticated, isSecurity]);

  // Hindari render konten sebelum verifikasi role selesai
  if (!isAuthenticated || !isSecurity) return null;

  return (
    <Suspense fallback="...">
      <Outlet />
    </Suspense>
  );
}
